export default __webpack_public_path__ + "static/media/empty-mailbox-web-blue.9636046c.png";